import TableCell from '@mui/material/TableCell'
import TableRow from '@mui/material/TableRow'
import moment from 'moment-timezone'
import { memo } from 'react'
import { Field } from 'react-final-form'

import useStyles from '../styles'

interface Props {
  fieldName: string
}

function ScansRow({ fieldName }: Props): JSX.Element {
  const classes = useStyles()

  return (
    <TableRow className={classes.tableRow}>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.createdAt`}>
          {({ input }) => (
            <p>
              {moment
                .unix(input.value)
                .tz(Intl.DateTimeFormat().resolvedOptions().timeZone)
                .format('M/D/YY h:mm A z')}
            </p>
          )}
        </Field>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.trackingId`}>{({ input }) => input.value || '--'}</Field>
      </TableCell>
      <TableCell className={classes.bodyCell}>
        <Field name={`${fieldName}.type`}>{({ input }) => <p>{input.value}</p>}</Field>
      </TableCell>
    </TableRow>
  )
}

export default memo(ScansRow)
